var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(23 93)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-23 -93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 93)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.656,10.781H13.125a2.346,2.346,0,0,0-2.344,2.344v4.531A2.346,2.346,0,0,0,13.125,20h4.531A2.346,2.346,0,0,0,20,17.656V13.125A2.346,2.346,0,0,0,17.656,10.781Zm.781,6.875a.782.782,0,0,1-.781.781H13.125a.782.782,0,0,1-.781-.781V13.125a.782.782,0,0,1,.781-.781h4.531a.782.782,0,0,1,.781.781ZM6.875,10.781H2.344A2.346,2.346,0,0,0,0,13.125v4.531A2.346,2.346,0,0,0,2.344,20H6.875a2.346,2.346,0,0,0,2.344-2.344V13.125A2.346,2.346,0,0,0,6.875,10.781Zm.781,6.875a.782.782,0,0,1-.781.781H2.344a.782.782,0,0,1-.781-.781V13.125a.782.782,0,0,1,.781-.781H6.875a.782.782,0,0,1,.781.781ZM6.875,0H2.344A2.346,2.346,0,0,0,0,2.344V6.875A2.346,2.346,0,0,0,2.344,9.219H6.875A2.346,2.346,0,0,0,9.219,6.875V2.344A2.346,2.346,0,0,0,6.875,0Zm.781,6.875a.782.782,0,0,1-.781.781H2.344a.782.782,0,0,1-.781-.781V2.344a.782.782,0,0,1,.781-.781H6.875a.782.782,0,0,1,.781.781ZM17.656,0H13.125a2.346,2.346,0,0,0-2.344,2.344V6.875a2.346,2.346,0,0,0,2.344,2.344h4.531A2.346,2.346,0,0,0,20,6.875V2.344A2.346,2.346,0,0,0,17.656,0Zm.781,6.875a.782.782,0,0,1-.781.781H13.125a.782.782,0,0,1-.781-.781V2.344a.782.782,0,0,1,.781-.781h4.531a.782.782,0,0,1,.781.781Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.ddf0d4ea.svg";
export { ForwardRef as ReactComponent };